import Card from 'components/Card/Card.jsx';
import React, { Component } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import Form from 'react-jsonschema-form';
import { connect } from 'react-redux';
//Redux
import { bindActionCreators } from 'redux';
import fields from '../../lib/fields';
import widgets from '../../lib/widgets';
import SelectRemoteWidget from '../../lib/widget-selectRemote';
import * as PressKitsActions from './redux/PressKitsActions';

const schema = {
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  $id: 'http://example.com/root.json',
  type: 'object',
  required: ['title', 'image', 'description', 'category', 'nav'],
  properties: {
    title: {
      $id: '#/properties/title',
      type: 'string',
      title: 'Título',
      default: '',
      examples: ['String'],
      pattern: '^(.*)$'
    },
    image: {
      $id: '#/properties/image',
      type: 'string',
      title: 'Imagen'
    },
    description: {
      $id: '#/properties/description',
      type: 'string',
      title: 'Descripción',
      default: '',
      examples: ['String'],
      pattern: '^(.*)$'
    },
    category: {
      $id: '#/properties/category',
      type: 'string',
      title: 'Categoría',
      enum: ['mexico', 'novias'],
      enumNames: ['Mexico', 'Novias']
    },
    nav: {
      $id: '#/properties/nav',
      type: 'array',
      title: 'Archivos',
      required: [],
      items: {
        $id: '#/properties/nav/items',
        type: 'object',
        title: 'Archivo',
        required: [],
        properties: {
          collectionLink: {
            $id: '#/properties/nav/properties/collectionLink',
            type: 'string',
            title: 'Link de colección',
            default: '',
            examples: ['String'],
            pattern: '^(.*)$'
          },
          campaignLink: {
            $id: '#/properties/nav/properties/campaignLink',
            type: 'string',
            title: 'Link de campaña',
            default: '',
            examples: ['String'],
            pattern: '^(.*)$'
          },
          downloadLink: {
            $id: '#/properties/nav/properties/downloadLink',
            type: 'string',
            title: 'Archivo',
            default: '',
            examples: ['String'],
            pattern: '^(.*)$'
          }
        }
      }
    }
  }
};

const uiSchema = {
  image: {
    'ui:field': 'UploadField'
  },
  nav: {
    items: {
      downloadLink: {
        'ui:field': 'UploadField'
      }
    }
  }
};

const log = type => console.log.bind(console, type);

class PressKitsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      openConfirm: false,
      openSuccess: false
    };

    console.log('Props', props.match.params);
  }

  componentWillMount() {
    if (this.state.id !== 'create') this.props.findById(this.state.id);
  }

  onSubmit = ({ formData }) => {
    let _this = this;
    console.log('Data submitted: ', formData);
    if (
      formData.password === '' ||
      formData.password === undefined ||
      formData.password == null
    )
      delete formData.password;

    if (this.state.id !== 'create') {
      this.props.update(formData.id, formData).then(function() {
        _this.props.history.push('/admin/press-kits');
      });
    } else {
      this.props.create(formData).then(function() {
        _this.props.history.push('/admin/press-kits');
      });
    }
  };

  onDelete(confirm = false) {
    let _this = this;
    if (confirm) {
      this.props.remove(this.state.id).then(function() {
        _this.props.history.push('/admin/press-kits');
      });
    } else {
      this.setState({ openConfirm: true });
    }
  }

  onBlur = (id, value) => {
    console.log('Data submitted: ', this.state.formData);
  };

  render() {
    let { history, PressKits } = this.props;
    let { id, openConfirm, openSuccess } = this.state;
    return (
      <div className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás desaser está opción!
          </SweetAlert>
        )}

        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Listo!"
            confirmBtnBsStyle="info"
            onConfirm={() => this.setState({ openSuccess: false })}
          >
            Se ha actualizado correctamente!
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={<legend>Editar Usuario</legend>}
                content={
                  <div>
                    <Form
                      schema={schema}
                      widgets={widgets}
                      fields={fields}
                      uiSchema={uiSchema}
                      onSubmit={this.onSubmit}
                      onBlur={this.onBlur}
                      formData={PressKits.formData}
                      onError={log('errors')}
                    >
                      <div>
                        <Button
                          bsStyle="success"
                          type="submit"
                          className="btn-fill"
                        >
                          Guardar
                        </Button>{' '}
                        <Button
                          bsStyle="default"
                          onClick={() => history.push('/press-kits')}
                        >
                          Cancelar
                        </Button>
                        <div className="pull-right">
                          {id !== 'create' ? (
                            <Button
                              bsStyle="danger"
                              onClick={() => this.onDelete(false)}
                            >
                              Borrar
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    </Form>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    PressKits: state.PressKits
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(PressKitsActions, dispatch);
};

const PressKitsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(PressKitsForm);

export default PressKitsConnect;



// WEBPACK FOOTER //
// ./src/views/PressKits/PressKitsForm.jsx